module.exports = __webpack_public_path__ + "img/2.61be9ffb.jpg";